import type { ReactNode } from "react"

type Props = {
  eyebrow?: ReactNode    // accepts plain text OR a Link / breadcrumb React node
  title: string
  subtitle?: ReactNode   // string OR composed badges/links
  actions?: ReactNode
}

// Standard page header — eyebrow / title / optional actions on the right.
// Used at the top of every Inertia page so the spacing + type stays
// uniform.
//
// Mobile-first: stacks vertically by default. Title + actions sit
// side-by-side starting at `md:` (768 px) where there's room. On phones,
// actions wrap below the heading without forcing the title text to
// truncate.
export function PageHeader({ eyebrow, title, subtitle, actions }: Props) {
  return (
    <section className="flex flex-col gap-4 md:flex-row md:items-start md:justify-between">
      <div className="min-w-0">
        {eyebrow && <div className="text-sm text-app-muted">{eyebrow}</div>}
        <h1 className="mt-1 text-3xl font-semibold tracking-tight md:text-4xl">{title}</h1>
        {/* `div` not `p` — subtitle prop accepts arbitrary ReactNode, including
            composed badges/links/divs. A `p` parent triggers React hydration
            errors (`<div> cannot be a descendant of <p>`) when callers pass
            block-level children. */}
        {subtitle && <div className="mt-1 text-sm text-app-muted">{subtitle}</div>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-3">{actions}</div>}
    </section>
  )
}
